import {
  FETCH_ERROR,
  FETCH_SUCCESS,
  IS_DRAWER_VISIBLE,
  FZ_FORM_LOADING
} from "../../constants/ActionTypes";
import axios from 'util/Api'

export const createUserRequest = (data) => {
  console.log(data);
  return (dispatch) => {
    dispatch({type: FZ_FORM_LOADING,payload:true});
     axios.post('fz/customer/create',data)
      .then(({data}) => {
        if(data.status) {
          dispatch({type: FETCH_SUCCESS, payload: data.message});
          dispatch({type: FZ_FORM_LOADING,payload:false});
          dispatch({type: IS_DRAWER_VISIBLE, payload: false});
        }
      }).catch(function (error) {
        const msg=getFirstError(error);
        dispatch({type: FETCH_ERROR,payload:msg});
    });
  }
};

export const handleDrawer = (status) => {
  return (dispatch) => {
    dispatch({type: IS_DRAWER_VISIBLE, payload: status});
  }
};

export const getFirstError=(error)=>{
  const {data}=error.response;
  const keys=Object.keys(data);
  const msg=data[keys[0]][0];
  return msg;
}
